import { Bars3Icon } from '@heroicons/react/20/solid';

import { SafeTopSpacer } from '@/renderer/utils/safeTop';

function SkeletonDMPreview() {
  return (
    <div className="block space-y-2 px-4 py-3 ">
      <div className="flex w-full items-baseline justify-between py-[2px]">
        <div className="h-4 w-24 animate-pulse rounded-sm bg-zinc-200 dark:bg-zinc-700" />
        <div className="h-4 w-6 animate-pulse rounded-sm bg-zinc-200 dark:bg-zinc-700" />
      </div>
      <div className="flex items-center justify-between py-[2px]">
        <div className="h-4 w-48 animate-pulse rounded-sm bg-zinc-200 dark:bg-zinc-700" />
        <div className="h-4 w-4 shrink-0 animate-pulse rounded-full bg-zinc-200 dark:bg-zinc-700" />
      </div>
    </div>
  );
}

function SkeletonDMList({ withHeader = true, messages = 20 }) {
  if (!withHeader) {
    return Array(messages)
      .fill(1)
      .map((_, index) => <SkeletonDMPreview key={index} />);
  }

  return (
    <div className="max-h-[100dvh] space-y-1 overflow-hidden sm:space-y-4">
      {/* Placeholder for renderer/Header, which the loaded list renders. It has
          to carry the iOS status-bar inset the same way that header does, or
          this skeleton starts at y=0 and draws into the Dynamic Island for as
          long as the ./DMList chunk takes to arrive (#2053). SafeTopSpacer also
          registers this bar as its pane's inset owner, so the pane doesn't take
          the layout's fallback padding on top of the spacer. env() is 0 on web
          / Android, where this is a 0px-tall div. */}
      <SafeTopSpacer />
      <div className="relative flex px-4 py-1">
        <label
          htmlFor="nav-checkbox"
          className="flex items-center justify-center rounded-sm p-1 hover:bg-zinc-900/5 md:hidden dark:hover:bg-white/5"
        >
          <Bars3Icon
            height={20}
            className="m-auto size-5 shrink-0 text-zinc-800 md:hidden dark:text-zinc-300"
          />
        </label>
        <div className="h-8 animate-pulse rounded-sm bg-zinc-200 dark:bg-zinc-700" />
      </div>
      <div className="divide-y divide-zinc-900/10 border-zinc-900/10 border-t dark:divide-white/10 dark:border-white/10">
        {Array(messages)
          .fill(1)
          .map((_, index) => (
            <SkeletonDMPreview key={index} />
          ))}
      </div>
    </div>
  );
}

export default SkeletonDMList;
